import classnames from 'classnames';
import { MouseEvent } from 'react';
import { Button } from '@components/v3/atoms/button';
import styles from './fixtureCardFourthSlot.module.scss';
import { FixtureCardFourthSlotProps } from './fixtureCardFourthSlot.types';

const FixtureCardFourthSlot = ({
  nativeProps,
  classNames,
  ctaLinks,
  addToCalendarData,
  matchCentreCta,
}: FixtureCardFourthSlotProps) => {
  const classes = classnames(
    [styles.tokens, styles.fixtureCardFourthSlot],
    classNames
  );

  const hasCtaLinks = ctaLinks && ctaLinks.length > 0;
  const hasAddToCalendar = !!addToCalendarData;

  if (!hasCtaLinks && !hasAddToCalendar && !matchCentreCta) {
    return null;
  }

  // Stop propagation to prevent parent card link from capturing clicks
  const handleCtaClick = (e: MouseEvent) => {
    e.stopPropagation();
  };

  return (
    <div
      {...nativeProps}
      className={classes}
      data-component="FixtureCardFourthSlot"
    >
      {(hasCtaLinks || hasAddToCalendar) && (
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
        <div className={styles.ctaContainer} onClick={handleCtaClick}>
          {ctaLinks?.map((cta) => (
            <Button key={cta.text} {...cta} />
          ))}
        </div>
      )}

      {matchCentreCta && (
        <div className={styles.matchCentreCtaContainer}>
          <Button {...matchCentreCta} />
        </div>
      )}
    </div>
  );
};

export default FixtureCardFourthSlot;
